require('es6-promise').polyfill();
import fetch from 'isomorphic-fetch';

var config = require('./config');

export const REQUEST_HEADERS = {
  CONTENT_TYPE: 'application/json',
  AUTHORIZATION_KEY: 'x-access-token'
}

export function generateUrl(controller, id = null, additionalRoutes = []) {
  let url = id ? config.apiBaseUrl + '/' + controller + '/' + id
    : config.apiBaseUrl + '/' + controller;

  if (additionalRoutes) {
    if (Array.isArray(additionalRoutes))
      return url + '/' + additionalRoutes.join('/')
    return url + '/' + additionalRoutes
  }

  return url;
}

export function generateFileUrl(fileName, uniqueIdentifier) {
  return encodeURI(uniqueIdentifier
    ? config.fileBaseUrl + '/' + uniqueIdentifier + '/' + fileName
    : config.fileBaseUrl + '/' + fileName);
}

export function apiGet(controller, token, id = null, additionalRoutes = []) {
  return fetch(generateUrl(controller, id, additionalRoutes), {
    method: "GET",
    headers: {
      'Accept': REQUEST_HEADERS.CONTENT_TYPE,
      'Content-Type': REQUEST_HEADERS.CONTENT_TYPE,
      'x-access-token': token
    }
  });
}

export function apiPost(controller, data, token, id = null, additionalRoutes = []) {
  let headers = {
    'Accept': REQUEST_HEADERS.CONTENT_TYPE,
    'Content-Type': REQUEST_HEADERS.CONTENT_TYPE
  };
  if (token) { headers[REQUEST_HEADERS.AUTHORIZATION_KEY] = token; }

  return fetch(generateUrl(controller, id, additionalRoutes), {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data)

  })
}


export function apiPut(controller, data, token, id = null, additionalRoutes = []) {
  let headers = {
    'Accept': REQUEST_HEADERS.CONTENT_TYPE,
    'Content-Type': REQUEST_HEADERS.CONTENT_TYPE
  };
  if (token) { headers[REQUEST_HEADERS.AUTHORIZATION_KEY] = token; }

  return fetch(generateUrl(controller, id, additionalRoutes), {
    method: "PUT",
    headers: headers,
    body: JSON.stringify(data)
  })
}

export function apiDelete(controller, token, id = null, additionalRoutes = []) {
  let headers = {
    'Accept': REQUEST_HEADERS.CONTENT_TYPE,
    'Content-Type': REQUEST_HEADERS.CONTENT_TYPE
  };
  if (token) { headers[REQUEST_HEADERS.AUTHORIZATION_KEY] = token; }

  return fetch(generateUrl(controller, id, additionalRoutes), {
    method: "DELETE",
    headers: headers
  })
}
